import AssetPreloader from './AssetPreloader';

export default AssetPreloader;
